export default {
	message: {
		cart: 'Shopping cart',
		home: 'Home Page',
		discountText: 'Up to 60% of all discount items',
		headingTitle: 'New product',
		addToCart: 'Add to cart',
		price: 'Price',
		rate: 'mark',
		TotalPrice: 'Total price',
		//
		goodNum: 'number',
		buyNow: 'BUY NOW',
		addCart: 'Add to cart',
		productDetailTitle: 'product details',
		productRecommendationsTitle: 'product recommendations',
		categoryTitle: 'product category',
		hotgoodstitle: 'best sellers',
		smallDetails: 'This product is currently popular for sale',
		orderSale: 'Sold',
		msgLanguage: 'Joined successfully',

    sort: 'sort',
    clear:'clear',
    dialogTitle:"Fill in the shipping address",
    dialogGivenName:"Recipient's surname",
    dialogSurname:"Recipient's name",
    dialogPhone:'phone number',
    dialogEmail:'Email',
    dialogPostalCode:'Postal Code',
    dialogAdminArea1:'Province/State',
    dialogAdminArea2:'City/Town/Village',
    dialogAddressLine1:'Street/house number',
    dialogAddressLine2:'Suite/Apartment Number',
    dialogPay: 'Go to payment',
    dialogClose: 'close',
    delete:'remove',
    formTips:'Please enter',
    selectPlaceholder:'Please select',
    cartEmpty:'The shopping cart is empty',
    detailSize:'size',

		//
		buyItNow: 'buy it now',
		shipping: 'shipping',
		pay: 'payment',
		back: 'Send back',
		support: 'support',
		shippingDesc: 'From a seller I handpicked',
		checkOut: 'Settle accounts',
		viewCart: 'View cart',
		agreePrivacy: 'I agree to the Privacy policy',
		remove: 'delete',
		total: 'total',
		language: 'language',

    searchPlaceholder: 'Search for the product you are looking for', //搜索一下你想找的商品
    // 联系我们字段
    openingHours: 'Hours', // 营业时间
    openingHoursText:'ALL WEEK FROM 10 AM TO 6 PM', //每周上午 10 点至下午 6 点
    contactEmail: 'Email', // 电子邮件
    companyName: 'The company', // 公司
    companyAddress: 'Address', // 地址
    contactPhone: 'Phone', // 电话号码
    // principalName: '회사 주체',// 公司主体人
    // principalName: '등록번호(CR)',// 公司注册号 (CR)
    // principalName: '상업등록번호(BR)',// 公司商证号 (BR)

		aboutUsText: 'About us',
		aboutUsContent: `<div class="product__tab--content__step">
      <h2 class="product__tab--content__title">About us</h2>
      <p>We are a clothing enterprise that integrates research and development, design, production, marketing, and promotion.</p>
      <p> Adhere to the needs of delicate women, maintaining a certain level of design, material selection, cutting, and every detail, making a light classic style with connotation, style, and spirituality within reach.</p>
      <p> Dresses with unique designs, exquisite fabrics, and precise cutting have been highly sought after for many years. Committed to integrating life, art, fashion, culture, and personality, providing consumers with a high-quality fashion lifestyle experience.</p>
    </div>`,
		contactUsText: 'Contract us',
		contactUsContent: `<div class="product__tab--content__step">
    <h2 class="product__tab--content__title">Contract us</h2>
    <p>Hours: ALL WEEK FROM 10 AM TO 6 PM</p>
    <p>Email:</p>
    <p>chloeannfountain691@gmail.com</p>
   
    <p>The company:</p>
    <p>HK POETRY FANGTANG INTERNATIONAL HEALTH MANAGEMENT CO., LIMITED</p>
    <p>Address:FLAT/RM B 5/F GAYLORD COMMERCIAL BUILDING 114-118 LOCKHART ROAD HK</p>
    </div>`,
		refundsText: 'Returns & Exchanges',
		refundsContent: `<div class="product__tab--content__step">
      <h2 class="product__tab--content__title">Returns & Rexfunds & Exchanges</h2>
      <p>Customers have the right to apply for a return within 15days after the receipt of the product</p>
      <p>To be eligible for a return, your item must be unused and in the same condition that you received it. It must also be in the original packaging.</p>
      <p>To complete your return, we require a receipt or proof of purchase.</p>
      <p>Please do not send your purchased product back to the manufacturer.</p>
      <p>Refunds (if applicable)</p>
      <p>Once your return is received and inspected, we will send you an email to notify you that we have received your returned item. We will also notify you of the approval or rejection of your refund.</p>
      <p>If you are approved, then your refund will be processed, and a credit will automatically be applied to your credit card or original method of payment, within a certain amount of days.</p>
      <p>Late or missing refunds (if applicable)</p>
      <p>If you haven’t received a refund yet, first check your bank account again.</p>
      <p>Then contact your credit card company, it may take some time before your refund is officially posted.</p>
      <p>Next contact your bank. There is often some processing time before a refund is posted.</p>
      <p>If you’ve done all of this and you still have not received your refund yet, please contact us.</p>
      <p>Sale items (if applicable)</p>
      <p>Only regular priced items may be refunded, unfortunately sale items cannot be refunded.</p>
      <p>Exchanges (if applicable)</p>
      <p>We only replace items if they are defective or damaged. If you need to exchange it for the same item, send us an email then we will give you the address for you returning the product.</p>
      <p>Gifts</p>
      <p>If the item was marked as a gift when purchased and shipped directly to you, you’ll receive a gift credit for the value of your return. Once the returned item is received, a gift certificate will be mailed to you.</p>
      <p>If the item wasn’t marked as a gift when purchased, or the gift giver had the order shipped to themselves to give to you later, we will send a refund to the gift giver and he will find out about your return.</p>
      <p>Shipping</p>
      <p>To return your product, you should mail us first for the details informati</p>
      <p>Refund policy:</p>
      <p>Refund requires deduction of relevant handling fees</p>
      <p>Return address: 2nd floor, Building 1, 650-41, Shinan dong, Incheon West District, South Korea</p>
    </div>`,
		privacyText: 'Privacy Policy',
		privacyContent: `
      <div class="product__tab--content__step">
        <h2 class="product__tab--content__title">Privacy Policy</h2>
        <p>WHAT DO WE DO WITH YOUR INFORMATION?</p>
        <p>When you purchase something from our store, as part of the buying and selling process, we collect the personal information you give us such as your name, address and email address.</p>
        <p>When you browse our store, we also automatically receive your computer’s internet protocol (IP) address in order to provide us with information that helps us learn about your browser and operating system.</p>
        <p>Email marketing (if applicable): With your permission, we may send you emails about our store, new products and other updates.</p>
        <p>PRIVACY SECURITY</p>
        <p>We will not sell, trade or rent personally identifiable information to any person or any company as part of our regular course of business. But you shall also keep your account information safe and do not disclose account information to others.</p>
        <p>How do I unsubscribe?</p>
        <p>You can unsubscribe by using the link at the bottom of any email newsletter, or change your subscription settings in your website user account page.</p>
        <p>Contact us</p>
        <p>If you have any questions, comments or requests regarding this privacy policy or our processing of your information, please do not hesitate to contact us.</p>
      </div>
    `,
		shippingText: 'Shipping',
		shippingContent: `<div class="product__tab--content__step ">
      <h2 class="product__tab--content__title">Shipping</h2>
      <p>Total Delivery Time = Processing Time + Shipping Time</p>
      <p>Customers will only be charged once at most for shipping costs (this includes returns); No-restocking to be charged to the consumers for the return of the product.</p>
      <p class="mb-2">Process Time: Before ships out we conduct Quality Control checks and testing in order to ensure the product's quality prior to shipment. 5-10 business days Normally. However, it can also be affected by the item's stock status. For popular items experiencing stock availability issues, the processing time may be 8-15 business days.</p>
      <p>We are an overseas website, international logistics</p>
    </div>`,
		termsText: 'Terms & Conditions',
		termsContent: `<div class="product__tab--content__step">
    <h2 class="product__tab--content__title">Terms & Conditions</h2>
    <strong>OVERVIEW</strong>
    <p>We offers this website, including all information, tools and services available from this site to you, the user, conditioned upon your acceptance of all terms, conditions, policies and notices stated here.</p>
    <p>By visiting our site and/ or purchasing something from us, you engage in our “Service” and agree to be bound by the following terms and conditions (“Terms of Service”, “Terms”), including those additional terms and conditions and policies referenced herein and/or available by hyperlink. These Terms of Service apply to all users of the site, including without limitation users who are browsers, vendors, customers, merchants, and/ or contributors of content.</p>
    <p>Please read these Terms of Service carefully before accessing or using our website. By accessing or using any part of the site, you agree to be bound by these Terms of Service. If you do not agree to all the terms and conditions of this agreement, then you may not access the website or use any services. If these Terms of Service are considered an offer, acceptance is expressly limited to these Terms of Service.</p>
    <p>Any new features or tools which are added to the current store shall also be subject to the Terms of Service. You can review the most current version of the Terms of Service at any time on this page. We reserve the right to update, change or replace any part of these Terms of Service by posting updates and/or changes to our website. It is your responsibility to check this page periodically for changes. Your continued use of or access to the website following the posting of any changes constitutes acceptance of those changes.
    </p>
    <p>Our store is hosted on Shopify Inc. They provide us with the online e-commerce platform that allows us to sell our products and services to you.</p>
    <ol>
      <li>
        <h5>1.ONLINE STORE TERMS</h5>
        <p>By agreeing to these Terms of Service, you represent that you are at least the age of majority in your state or province of residence, or that you are the age of majority in your state or province of residence and you have given us your consent to allow any of your minor dependents to use this site.</p>
        <p>You may not use our products for any illegal or unauthorized purpose nor may you, in the use of the Service, violate any laws in your jurisdiction (including but not limited to copyright laws).
          You must not transmit any worms or viruses or any code of a destructive nature.</p>
        <p>A breach or violation of any of the Terms will result in an immediate termination of your Services.</p>
      </li>
      <li>
        <h5>2.GENERAL CONDITIONS</h5>
        <p>We reserve the right to refuse service to anyone for any reason at any time.</p>
        <p>You understand that your content (not including credit card information), may be transferred unencrypted and involve (a) transmissions over various networks; and (b) changes to conform and adapt to technical requirements of connecting networks or devices. Credit card information is always encrypted during transfer over networks.</p>
        <p>You agree not to reproduce, duplicate, copy, sell, resell or exploit any portion of the Service, use of the Service, or access to the Service or any contact on the website through which the service is provided, without express written permission by us.</p>
        <p>The headings used in this agreement are included for convenience only and will not limit or otherwise affect these Terms.</p>
      </li>
      <li>
        <h5>3.ACCURACY, COMPLETENESS AND TIMELINESS OF INFORMATION</h5>
        <p>We are not responsible if information made available on this site is not accurate, complete or current. The material on this site is provided for general information only and should not be relied upon or used as the sole basis for making decisions without consulting primary, more accurate, more complete or more timely sources of information. Any reliance on the material on this site is at your own risk.</p>
        <p>This site may contain certain historical information. Historical information, necessarily, is not current and is provided for your reference only. We reserve the right to modify the contents of this site at any time, but we have no obligation to update any information on our site. You agree that it is your responsibility to monitor changes to our site.</p>
      </li>
      <li>
        <h5>4.MODIFICATIONS TO THE SERVICE AND PRICES</h5>
        <p>Prices for our products are subject to change without notice.</p>
        <p>We reserve the right at any time to modify or discontinue the Service (or any part or content thereof) without notice at any time.</p>
        <p>We shall not be liable to you or to any third-party for any modification, price change, suspension or discontinuance of the Service.</p>
      </li>
      <li>
        <h5>5.PRODUCTS OR SERVICES (if applicable)</h5>
        <p>Certain products or services may be available exclusively online through the website. These products or services may have limited quantities and are subject to return or exchange only according to our Return Policy.</p>
        <p>We have made every effort to display as accurately as possible the colors and images of our products that appear at the store. We cannot guarantee that your computer monitor's display of any color will be accurate.</p>
        <p>We reserve the right, but are not obligated, to limit the sales of our products or Services to any person, geographic region or jurisdiction. We may exercise this right on a case-by-case basis. We reserve the right to limit the quantities of any products or services that we offer. All descriptions of products or product pricing are subject to change at anytime without notice, at the sole discretion of us. We reserve the right to discontinue any product at any time. Any offer for any product or service made on this site is void where prohibited.</p>
        <p>We do not warrant that the quality of any products, services, information, or other material purchased or obtained by you will meet your expectations, or that any errors in the Service will be corrected.</p>
      </li>
      <li>
        <h5>6. ACCURACY OF BILLING AND ACCOUNT INFORMATION</h5>
        <p>We reserve the right to refuse any order you place with us. We may, in our sole discretion, limit or cancel quantities purchased per person, per household or per order. These restrictions may include orders placed by or under the same customer account, the same credit card, and/or orders that use the same billing and/or shipping address. In the event that we make a change to or cancel an order, we may attempt to notify you by contacting the e-mail and/or billing address/phone number provided at the time the order was made. We reserve the right to limit or prohibit orders that, in our sole judgment, appear to be placed by dealers, resellers or distributors.</p>
        <p>You agree to provide current, complete and accurate purchase and account information for all purchases made at our store. You agree to promptly update your account and other information, including your email address and credit card numbers and expiration dates, so that we can complete your transactions and contact you as needed.</p>
        <p>For more detail, please review our return policy</p>
      </li>
      <li>
        <h5>7.OPTIONAL TOOLS </h5>
        <p>We may provide you with access to third-party tools over which we neither monitor nor have any control nor input.</p>
        <p>You acknowledge and agree that we provide access to such tools ”as is” and “as available” without any warranties, representations or conditions of any kind and without any endorsement. We shall have no liability whatsoever arising from or relating to your use of optional third-party tools.</p>
        <p>Any use by you of optional tools offered through the site is entirely at your own risk and discretion and you should ensure that you are familiar with and approve of the terms on which tools are provided by the relevant third-party provider(s).</p>
        <p>We may also, in the future, offer new services and/or features through the website (including, the release of new tools and resources). Such new features and/or services shall also be subject to these Terms of Service.</p>
      </li>
      <li>
        <h5>8.THIRD-PARTY LINKS</h5>
        <p>Certain content, products and services available via our Service may include materials from third-parties.</p>
        <p>Third-party links on this site may direct you to third-party websites that are not affiliated with us. We are not responsible for examining or evaluating the content or accuracy and we do not warrant and will not have any liability or responsibility for any third-party materials or websites, or for any other materials, products, or services of third-parties.</p>
        <p>We are not liable for any harm or damages related to the purchase or use of goods, services, resources, content, or any other transactions made in connection with any third-party websites. Please review carefully the third-party's policies and practices and make sure you understand them before you engage in any transaction. Complaints, claims, concerns, or questions regarding third-party products should be directed to the third-party.</p>
      </li>
      <li>
        <h5>9.USER COMMENTS, FEEDBACK AND OTHER SUBMISSIONS</h5>
        <p>If, at our request, you send certain specific submissions (for example contest entries) or without a request from us you send creative ideas, suggestions, proposals, plans, or other materials, whether online, by email, by postal mail, or otherwise (collectively, 'comments'), you agree that we may, at any time, without restriction, edit, copy, publish, distribute, translate and otherwise use in any medium any comments that you forward to us. We are and shall be under no obligation (1) to maintain any comments in confidence; (2) to pay compensation for any comments; or (3) to respond to any comments.</p>
        <p>We may, but have no obligation to, monitor, edit or remove content that we determine in our sole discretion are unlawful, offensive, threatening, libelous, defamatory, pornographic, obscene or otherwise objectionable or violates any party’s intellectual property or these Terms of Service.</p>
        <p>You agree that your comments will not violate any right of any third-party, including copyright, trademark, privacy, personality or other personal or proprietary right. You further agree that your comments will not contain libelous or otherwise unlawful, abusive or obscene material, or contain any computer virus or other malware that could in any way affect the operation of the Service or any related website. You may not use a false e-mail address, pretend to be someone other than yourself, or otherwise mislead us or third-parties as to the origin of any comments. You are solely responsible for any comments you make and their accuracy. We take no responsibility and assume no liability for any comments posted by you or any third-party.</p>
      </li>
      <li>
        <h5>10.PERSONAL INFORMATION</h5>
        <p>Your submission of personal information through the store is governed by our Privacy Policy. To view our privacy policy</p>
      </li>
      <li>
        <h5>11.ERRORS, INACCURACIES AND OMISSIONS</h5>
        <p>Occasionally there may be information on our site or in the Service that contains typographical errors, inaccuracies or omissions that may relate to product descriptions, pricing, promotions, offers, product shipping charges, transit times and availability. We reserve the right to correct any errors, inaccuracies or omissions, and to change or update information or cancel orders if any information in the Service or on any related website is inaccurate at any time without prior notice (including after you have submitted your order).</p>
        <p>We undertake no obligation to update, amend or clarify information in the Service or on any related website, including without limitation, pricing information, except as required by law. No specified update or refresh date applied in the Service or on any related website, should be taken to indicate that all information in the Service or on any related website has been modified or updated.</p>
      </li>
      <li>
        <h5>12.PROHIBITED USES</h5>
        <p>In addition to other prohibitions as set forth in the Terms of Service, you are prohibited from using the site or its content: (a) for any unlawful purpose; (b) to solicit others to perform or participate in any unlawful acts; (c) to violate any international, federal, provincial or state regulations, rules, laws, or local ordinances; (d) to infringe upon or violate our intellectual property rights or the intellectual property rights of others; (e) to harass, abuse, insult, harm, defame, slander, disparage, intimidate, or discriminate based on gender, sexual orientation, religion, ethnicity, race, age, national origin, or disability; (f) to submit false or misleading information; (g) to upload or transmit viruses or any other type of malicious code that will or may be used in any way that will affect the functionality or operation of the Service or of any related website, other websites, or the Internet; (h) to collect or track the personal information of others; (i) to spam, phish, pharm, pretext, spider, crawl, or scrape; (j) for any obscene or immoral purpose; or (k) to interfere with or circumvent the security features of the Service or any related website, other websites, or the Internet. We reserve the right to terminate your use of the Service or any related website for violating any of the prohibited uses.</p>
      </li>
      <li>
        <h5>13.DISCLAIMER OF WARRANTIES; LIMITATION OF LIABILITY</h5>
        <p>We do not guarantee, represent or warrant that your use of our service will be uninterrupted, timely, secure or error-free.</p>
        <p>We do not warrant that the results that may be obtained from the use of the service will be accurate or reliable.</p>
        <p>You agree that from time to time we may remove the service for indefinite periods of time or cancel the service at any time, without notice to you.</p>
        <p>You expressly agree that your use of, or inability to use, the service is at your sole risk. The service and all products and services delivered to you through the service are (except as expressly stated by us) provided 'as is' and 'as available' for your use, without any representation, warranties or conditions of any kind, either express or implied, including all implied warranties or conditions of merchantability, merchantable quality, fitness for a particular purpose, durability, title, and non-infringement.</p>
        <p>In no case shall our directors, officers, employees, affiliates, agents, contractors, interns, suppliers, service providers or licensors be liable for any injury, loss, claim, or any direct, indirect, incidental, punitive, special, or consequential damages of any kind, including, without limitation lost profits, lost revenue, lost savings, loss of data, replacement costs, or any similar damages, whether based in contract, tort (including negligence), strict liability or otherwise, arising from your use of any of the service or any products procured using the service, or for any other claim related in any way to your use of the service or any product, including, but not limited to, any errors or omissions in any content, or any loss or damage of any kind incurred as a result of the use of the service or any content (or product) posted, transmitted, or otherwise made available via the service, even if advised of their possibility.</p>
        <p>Because some states or jurisdictions do not allow the exclusion or the limitation of liability for consequential or incidental damages, in such states or jurisdictions, our liability shall be limited to the maximum extent permitted by law.</p>
      </li>
      <li>
        <h5>14.INDEMNIFICATION</h5>
        <p>You agree to indemnify, defend and hold harmless our companyand our parent, subsidiaries, affiliates, partners, officers, directors, agents, contractors, licensors, service providers, subcontractors, suppliers, interns and employees, harmless from any claim or demand, including reasonable attorneys’ fees, made by any third-party due to or arising out of your breach of these Terms of Service or the documents they incorporate by reference, or your violation of any law or the rights of a third-party.</p>
      </li>
      <li>
        <h5>15.SEVERABILITY</h5>
        <p>In the event that any provision of these Terms of Service is determined to be unlawful, void or unenforceable, such provision shall nonetheless be enforceable to the fullest extent permitted by applicable law, and the unenforceable portion shall be deemed to be severed from these Terms of Service, such determination shall not affect the validity and enforceability of any other remaining provisions.</p>
      </li>
      <li>
        <h5>16.TERMINATION</h5>
        <p>The obligations and liabilities of the parties incurred prior to the termination date shall survive the termination of this agreement for all purposes.</p>
        <p>These Terms of Service are effective unless and until terminated by either you or us. You may terminate these Terms of Service at any time by notifying us that you no longer wish to use our Services, or when you cease using our site.</p>
        <p>If in our sole judgment you fail, or we suspect that you have failed, to comply with any term or provision of these Terms of Service, we also may terminate this agreement at any time without notice and you will remain liable for all amounts due up to and including the date of termination; and/or accordingly may deny you access to our Services (or any part thereof).</p>
      </li>
      <li>
        <h5>17.ENTIRE AGREEMENT</h5>
        <p>The failure of us to exercise or enforce any right or provision of these Terms of Service shall not constitute a waiver of such right or provision.</p>
        <p>These Terms of Service and any policies or operating rules posted by us on this site or in respect to The Service constitutes the entire agreement and understanding between you and us and govern your use of the Service, superseding any prior or contemporaneous agreements, communications and proposals, whether oral or written, between you and us (including, but not limited to, any prior versions of the Terms of Service).</p>
        <p>Any ambiguities in the interpretation of these Terms of Service shall not be construed against the drafting party.</p>
        </li>
        <li>
          <h5>18.CHANGES TO TERMS OF SERVICE</h5>
          <p>You can review the most current version of the Terms of Service at any time at this page.</p>
          <p>We reserve the right, at our sole discretion, to update, change or replace any part of these Terms of Service by posting updates and changes to our website. It is your responsibility to check our website periodically for changes. Your continued use of or access to our website or the Service following the posting of any changes to these Terms of Service constitutes acceptance of those changes</p>
        </li>
        <li>
          <h5>19.Governing Law</h5>
          <p>These Terms of Service and any separate agreement by which we provide services to you shall be governed by and construed in accordance with local law.</p>
        </li>
      </ol>
  </div>`,
	},
	// 商品列表
	//  productList: [
	//   {
	//     id: 1,
	//     imgUrl: "pro1-1.jpg",
	//     title: "SASAVIN蛋白棒",
	//     singlePrice: 54.85,
	//     bigProduct:['pro1-2.png','pro1-3.png']
	//   },
	//   {
	//     id: 2,
	//     imgUrl: "pro2-1.jpg",
	//     title: "朵匠、优姿轻解素、益生元多肽片压片糖果",
	//     singlePrice: 74.80,
	//     bigProduct:['pro2-2.jpg','pro2-3.jpg']

	//   },
	//   {
	//     id: 3,
	//     imgUrl: "pro3-1.jpg",
	//     title: "亨德仁源堂油切分解素双菇多肽粉固体饮料",
	//     singlePrice: 47.87,
	//     bigProduct:['pro3-2.jpg','pro3-3.jpg']

	//   },
	//   {
	//     id: 4,
	//     imgUrl: "pro4-1.jpg",
	//     title: "极魅曲然堂、低脂高纤型代餐营养粉",
	//     singlePrice: 68.81,
	//     bigProduct:['pro4-2.jpg','pro4-3.jpg']

	//   },
	//   {
	//     id: 5,
	//     imgUrl: "pro5-1.jpg",
	//     title: "蓝莓复合益生元固体饮料",
	//     singlePrice: 76.79,
	//     bigProduct:['pro5-2.jpg','pro5-3.jpg']

	//   },
	//   {
	//     id: 6,
	//     imgUrl: "pro6-1.jpg",
	//     title: "诺丽果低聚果糖压片",
	//     singlePrice: 74.80,
	//     bigProduct:['pro6-2.png','pro6-3.png']

	//   },
	//   {
	//     id: 7,
	//     imgUrl: "pro7-1.jpg",
	//     title: "奇亚籽固体饮料",
	//     singlePrice: 74.80,
	//     bigProduct:['pro7-2.jpg','pro7-3.jpg']

	//   },
	//   {
	//     id: 8,
	//     imgUrl: "pro8-1.jpg",
	//     title: "轻姿溶解素",
	//     singlePrice: 150.59,
	//     bigProduct:['pro8-2.jpg','pro8-3.jpg']

	//   },
	//   {
	//     id: 9,
	//     imgUrl: "pro9-1.jpg",
	//     title: "神奇粉末，固体饮料",
	//     singlePrice: 45.88,
	//     bigProduct:['pro9-2.jpg','pro9-3.png']

	//   },
	//   {
	//     id: 10,
	//     imgUrl: "pro10-1.jpg",
	//     title: "神奇粉末益生菌果蔬植物酵素粉",
	//     singlePrice: 74.80,
	//     bigProduct:['pro10-2.jpg','pro10-3.png']

	//   },
	//   {
	//     id: 11,
	//     imgUrl: "pro11-1.jpg",
	//     title: "新活力因子",
	//     singlePrice: 51.86,
	//     bigProduct:['pro11-2.png','pro11-3.jpg','pro11-4.jpg']

	//   },
	//   {
	//     id: 12,
	//     imgUrl: "pro12-1.jpg",
	//     title: "新--芊润易简玫奇亚籽固体饮料",
	//     singlePrice: 74.80,
	//     bigProduct:['pro12-2.png','pro12-3.png']

	//   },
	//   {
	//     id: 13,
	//     imgUrl: "pro13-1.jpg",
	//     title: "伊美源、轻轻果冻果味型果冻",
	//     singlePrice: 74.80,
	//     bigProduct:['pro13-2.jpg','pro13-3.jpg']

	//   },
	//   {
	//     id: 14,
	//     imgUrl: "pro14-1.jpg",
	//     title: "植物三调茶",
	//     singlePrice: 74.80,
	//     bigProduct:['pro14-2.jpg','pro14-3.png','pro14-4.png']

	//   },
	//   {
	//     id: 15,
	//     imgUrl: "pro15-1_en.png",
	//     title: "make up the difference",
	//     singlePrice: 1,
	//     bigProduct:[]
	//   },
	// ],
	productList: [],

	cartList: [],

	retail: {
		id: 15,
		imgUrl: 'pro15-1_en.png',
		title: 'make up the difference',
		singlePrice: 1,
		isRetail: true,
	},
}
